import classNames from 'classnames';
import React, {RefObject, useEffect, useState} from 'react';

import {Icon, Popover, Text} from '@albert-io/atomic';

import './new-translation-toggle-tour.scss';

const useRerenderOnMount = () => {
  const [_rerenderToken, setRerenderToken] = useState(0);
  useEffect(() => {
    setRerenderToken((prev) => prev + 1);
  }, []);
};

interface Props {
  onDismissTour: () => void;
  popoverPlacement?: 'bottom-end' | 'top-end';
  translationToggleRef: RefObject<any>;
}

export default function NewTranslationToggleTour({
  onDismissTour,
  popoverPlacement = 'bottom-end',
  translationToggleRef
}: Props) {
  // Force a re-render the tick after the component mounts in case the ref is not set yet
  useRerenderOnMount();

  return (
    <Popover
      className={classNames(
        'new-translation-toggle-tour__popover',
        `new-translation-toggle-tour__popover--${popoverPlacement}`
      )}
      expanded
      optimizeForMobile={false}
      paddingLevel={0}
      position={popoverPlacement}
      targetRef={translationToggleRef}
      usePortal={false}
    >
      <div className='flex items-center gap-x1 content-primary-inverse-static'>
        <Text color='primary-inverse-static'>Turn on translations here</Text>
        {/* @ts-expect-error */}
        <Icon className='cursor-pointer' icon={['fal', 'times']} onClick={onDismissTour} />
      </div>
    </Popover>
  );
}
